'use client';

import { Flex, Icon, Text } from '@chakra-ui/react';
import { MdOutlineNotificationsActive } from 'react-icons/md';
import { ProductProps } from '@/types/Product';
import WishlistButton from '@/components/WishlistButton';
import WaitlistForm from '@/components/WaitlistForm';
import { isRayBanBrand, RayBanSeal } from '@/components/RayBanCertified';

type ComingSoonProps = {
  product: ProductProps;
};

const ComingSoon = ({ product }: ComingSoonProps) => (
  <Flex
    pos={{ base: 'fixed', md: 'sticky' }}
    data-bottom-bar
    top={{ base: 'unset', md: '90px' }}
    bottom={{ base: 0, md: 'unset' }}
    p={{ base: '16px', md: '24px' }}
    w="100%"
    h="fit-content"
    flexDir="column"
    gap="14px"
    bg={{ base: '#FFFFFF', _dark: '#0A1B2B' }}
    borderRadius={{ base: '20px 20px 0 0', md: '20px' }}
    boxShadow={{
      base: '0 -6px 40px rgba(0,0,0,0.14)',
      md: '0 4px 24px rgba(0,0,0,0.08)',
    }}
    zIndex={{ base: 1000, md: 'unset' }}
    border="1px solid"
    borderColor={{ base: 'rgba(0,0,0,0.1)', md: 'rgba(0,0,0,0.07)' }}
  >
    <Flex w="100%" align="center" justify="space-between" gap="12px">
      <Text
        as="h1"
        fontSize={{ base: '18px', md: '22px' }}
        fontWeight="700"
        color={{ base: '#0A1B2B', _dark: '#E2EFF5' }}
        lineHeight="1.3"
      >
        {product.name}
      </Text>
      <Flex align="center" gap="10px" flexShrink={0}>
        {isRayBanBrand(product.brand?.name) && <RayBanSeal size={44} />}
        <WishlistButton
          productId={product.id}
          productOptId={null}
          productOptLabel={null}
          size="md"
          pos="static"
        />
      </Flex>
    </Flex>

    <Flex
      align="center"
      gap="10px"
      py="12px"
      px="14px"
      borderRadius="12px"
      bg={{ base: 'rgba(0,176,202,0.08)', _dark: 'rgba(0,176,202,0.14)' }}
      border="1px solid rgba(0,176,202,0.25)"
    >
      <Icon fontSize="20px" color="#00B0CA" flexShrink={0}>
        <MdOutlineNotificationsActive />
      </Icon>
      <Flex flexDir="column" gap="2px">
        <Text fontSize="15px" fontWeight="700" color="#00B0CA">
          Disponível brevemente
        </Text>
        {product.coming_soon_note && (
          <Text
            fontSize="12px"
            color={{ base: 'rgba(0,0,0,0.6)', _dark: 'rgba(255,255,255,0.6)' }}
          >
            {product.coming_soon_note}
          </Text>
        )}
      </Flex>
    </Flex>

    <WaitlistForm
      productId={product.id}
      productOptId={null}
      variant="launch"
    />
  </Flex>
);

export default ComingSoon;
